export enum TransactionCode {
    BUY = 'BUY',
    SELL = 'SELL',
    SELL_FUTURE = 'SELL_FUTURE',
    BUY_FUTURE = 'BUY_FUTURE'
}